export function insideSingleLevelSameOriginIframe() {
  return (
    !!window.frameElement &&
    window.self !== window.top &&
    window.parent === window.top &&
    window.parent.location.origin === window.location.origin
  );
}

export function topLevelNonIframe() {
  return !window.frameElement && window === window.top && window === window.self;
}
